/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Scope_LabelInputs */

const en_explorer_search_scope_label = /** @type {(inputs: Explorer_Search_Scope_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scope`)
};

const fr_explorer_search_scope_label = /** @type {(inputs: Explorer_Search_Scope_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scope`)
};

const de_explorer_search_scope_label = /** @type {(inputs: Explorer_Search_Scope_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scope`)
};

const it_explorer_search_scope_label = /** @type {(inputs: Explorer_Search_Scope_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scope`)
};

const ru_explorer_search_scope_label = /** @type {(inputs: Explorer_Search_Scope_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scope`)
};

const es_explorer_search_scope_label = /** @type {(inputs: Explorer_Search_Scope_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scope`)
};

const zh_cn2_explorer_search_scope_label = /** @type {(inputs: Explorer_Search_Scope_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scope`)
};

const ja_explorer_search_scope_label = /** @type {(inputs: Explorer_Search_Scope_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scope`)
};

const hi_explorer_search_scope_label = /** @type {(inputs: Explorer_Search_Scope_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scope`)
};

const pt_pt2_explorer_search_scope_label = /** @type {(inputs: Explorer_Search_Scope_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scope`)
};

/**
* | output |
* | --- |
* | "Scope" |
*
* @param {Explorer_Search_Scope_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_scope_label = /** @type {((inputs?: Explorer_Search_Scope_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Scope_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_search_scope_label(inputs)
	if (locale === "de") return de_explorer_search_scope_label(inputs)
	if (locale === "it") return it_explorer_search_scope_label(inputs)
	if (locale === "ru") return ru_explorer_search_scope_label(inputs)
	if (locale === "es") return es_explorer_search_scope_label(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_search_scope_label(inputs)
	if (locale === "ja") return ja_explorer_search_scope_label(inputs)
	if (locale === "hi") return hi_explorer_search_scope_label(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_search_scope_label(inputs)
	return en_explorer_search_scope_label(inputs)
});